import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import AwaitingApprovalRow from './AwaitingApprovalRow';
import './MarketCenterReportTable.css';
import { v4 as uuidv4 } from 'uuid';
import { sortBy } from 'lodash';

class AwaitingReportTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableData: []
    };

    this.createRowData = this.createRowData.bind(this);
    this.normalizeData = this.normalizeData.bind(this);
    this.getRows = this.getRows.bind(this);
}

    normalizeData(data) {
        const awaitingApprovalData = Object.entries(data).map((renewal) => this.createRowData(renewal[1].branch.branchName, renewal[1].requiringApprovalCount));
        return sortBy([...awaitingApprovalData], ['branchCode']);
    }

    componentDidMount() {
      if (Object.entries(this.props.awaitingReportData).length > 0){
        this.setState({
            tableData: this.normalizeData(this.props.awaitingReportData)
          });
      }
    }

    createRowData(
        branchCode,
        recordCount
    ) {
        return {
            id: uuidv4(),
            branchCode,
            recordCount
        };
    }

    getRows() {
      const mcRows = this.state.tableData;
      return mcRows.map((data) => (
          <>
          <AwaitingApprovalRow {...data} />
          </>
      ));
    }

  render() {
    return (
      <div>
      { Object.entries(this.props.awaitingReportData).length > 0 ? 
        (
          <div className="mc-report-table-scroll-bar">
            <table className="mc-report-table">
              <thead>
                <tr key="report-sub-header" className="mc-report-sub-header">
                  <th>
                    {this.props.intl.formatMessage({ id: 'market_center' })}
                  </th>
                  <th>
                    {this.props.intl.formatMessage({ id: 'requiring_approval.title' })}
                  </th>
                </tr>
              </thead>
              <tbody>{this.getRows()}</tbody>
            </table>
          </div>) 
        : (
          <div>
            {this.props.intl.formatMessage({
              id: 'no_awaiting_approval_found'
            })}
          </div>
        )
      }
      </div>
    ) 
  }
}

export default injectIntl(AwaitingReportTable);